'use client';

import styles from './index.module.scss';
import { motion } from 'framer-motion';
import Card from '@components/Card';
import { useSlider } from './useSlider';

interface SliderItem {
  imgUrl: string;
  title: string;
  description: string;
  details: string;
}

interface SliderProps {
  sliderData: SliderItem[];
}

const Slider: React.FC<SliderProps> = ({ sliderData }) => {
  const {
    ref,
    width,
    xTranslation,
    dragControls,
    handleHoverStart,
    handleHoverEnd,
    handleDragStart,
    handleDragEnd,
  } = useSlider();

  return (
    <div className={styles.container}>
      <motion.div
        className={styles.motion}
        ref={ref}
        style={{ x: xTranslation }}
        drag="x"
        dragConstraints={width > 0 ? { left: -width / 2, right: 0 } : false}
        dragControls={dragControls}
        dragElastic={0.2}
        whileTap={{ cursor: 'grabbing' }}
        onHoverStart={handleHoverStart}
        onHoverEnd={handleHoverEnd}
        onDragStart={handleDragStart}
        onDragEnd={handleDragEnd}
      >
        {[...sliderData, ...sliderData].map((slide, i) => (
          <Card
            imgUrl={slide.imgUrl}
            key={i}
            title={slide.title}
            description={slide.description}
          />
        ))}
      </motion.div>
    </div>
  );
};

export default Slider;
